var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppPageContainer',{attrs:{"custom":1600,"min-height":0}},[_c('AppPageHeader',{attrs:{"design":"new","title":"AI analysis","compact":""}}),_c('AppTabs',{attrs:{"design":"new","refined":"","weight":"medium","tabs":_vm.tabs,"value":"first-reply"}}),_c('FirstReplyWorkspace')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }